// @ts-strict-ignore
import React from 'react';
import styled from 'styled-components';
import { HeightProps, WidthProps } from 'styled-system';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { colors, fontWeights, fonts, transition } from 'theme';

export const StyledSelect = styled.select.attrs<{
  disableGreyOnNull?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
}>(({ disableGreyOnNull, value }) => ({
  style:
    !disableGreyOnNull && (value === null || value === '')
      ? {
          color: colors.battleshipGrey,
        }
      : null,
}))<{ small?: boolean; hasError?: boolean }>`
  width: 100%;
  height: 45px;
  padding-left: 1em;
  padding-right: 36px;
  border: solid 1px ${colors.silver};
  color: ${colors.charcoalGrey};
  background-color: white;
  border-radius: 4px;
  appearance: none;
  font-size: 18px;
  font-family: ${fonts.sans};
  transition: all ${transition};
  &:focus {
    border-color: ${colors.waterBlue};
    box-shadow: 0 0 0 1px ${colors.waterBlue} inset;
    outline: 0;
  }
  ${(props) =>
    props.hasError &&
    `
    border-color: ${colors.scarlet};
    box-shadow: 0 0 0 1px ${colors.scarlet};
  `}
  &::-ms-expand {
    display: none;
  }
  option {
    color: ${colors.greyishBrown};
  }
  ${(props) =>
    props.small &&
    `
  height: 36px;
  padding-right: 48px;
  padding-left: 12px;
  background: transparent;
  color: ${colors.battleshipGrey};
  font-size: 16px;
  font-weight: ${fontWeights.semiBold};
  `}
`;

type Props = HeightProps &
  WidthProps & {
    'aria-label'?: string;
    id?: string;
    label?: string;
    className?: string;
    name?: string;
    customCompare?: (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg0: Record<string, any>,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg1: Record<string, any>
    ) => boolean;
    disableGreyOnNull?: boolean;
    disabled?: boolean;
    value?: string;
    options: ReadonlyArray<{
      value: string | null | undefined;
      label: string;
      disabled?: boolean;
    }>;
    onChange?: (arg0: string) => void;
    'data-qa-id'?: string;
    hasError?: boolean;
    small?: boolean;
    required?: boolean;
    placeholder?: string | null | undefined;
  };

export function SelectInput({
  name,
  value,
  options,
  onChange = () => undefined,
  hasError,
  small,
  ...props
}: Props) {
  return (
    <Box position="relative">
      <StyledSelect
        name={name}
        small={small}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        hasError={hasError}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {options.map(({ value: optionValue, label, ...optionProps }) => (
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/jsx-props-no-spreading
          <option key={optionValue} value={optionValue} {...optionProps}>
            {label}
          </option>
        ))}
      </StyledSelect>
      <Box
        position="absolute"
        top="50%"
        right={small ? 12 : 19}
        transform="translateY(-50%)"
        pointerEvents="none"
      >
        <Icon
          initialColorName="todo-replace-me"
          name="chevron-down"
          size={small ? 10 : 16}
        />
      </Box>
    </Box>
  );
}
